import { render } from "./index.vue?vue&type=template&id=2362134b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2362134b&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2362134b"],['__file',"src/vab/components/VabAvatar/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2362134b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2362134b', __exports__)) {
    console.log('reload')
    api.reload('2362134b', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2362134b&scoped=true", () => {
    console.log('re-render')
    api.rerender('2362134b', render)
  })

}


export default __exports__